import React from 'react'
import Complete from './SignupComplete'

const SignupComplete = ({user, ...props}) => (
  <Complete user={user} {...props} />
)

export default SignupComplete



// WEBPACK FOOTER //
// src/components/SignupComplete/index.js